import classnames from 'classnames';
import PropTypes from 'prop-types';
import React from 'react';

const ErrorMessage = ({ errorClasses, message }) => {
  if (!message) {
    return null;
  }

  const errorClassNames = classnames('error-message', errorClasses);

  return <span className={errorClassNames}>{message}</span>;
};

ErrorMessage.propTypes = {
  errorClasses: PropTypes.string,
  message: PropTypes.string,
};

export default ErrorMessage;



// WEBPACK FOOTER //
// ./src/scripts/presentation/components/lib/error_message.jsx